// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { axios } from './axios';
import { toast } from 'sonner';

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

// Registration-scoped discount codes (ADR 0026). amountOff is CENTS.
const useDiscountCodeStore = create(
  immer((set) => ({
    discountCodes: [],

    getDiscountCodes: (getToken) => async (registrationId) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(
          `${baseUrl}/discountCodes/registration/${registrationId}`,
          createAuthHeader(token),
        );
        if (data?.status === 1) {
          set((state) => { state.discountCodes = data.result || []; });
        }
      } catch (error) {
        console.error('getDiscountCodes failed', error);
      }
    },

    createDiscountCode: (getToken) => async (registrationId, payload) => {
      try {
        const token = await getToken();
        const { data } = await axios.post(
          `${baseUrl}/discountCodes/registration/${registrationId}`,
          payload,
          createAuthHeader(token),
        );
        if (data?.status === 1 && data.result?._id) {
          set((state) => { state.discountCodes.unshift(data.result); });
          toast.success(`Code ${data.result.code} created`);
          return data.result;
        }
        toast.error(data?.error || 'Could not create the discount code');
        return null;
      } catch (error) {
        toast.error(error?.response?.data?.error || 'Could not create the discount code');
        return null;
      }
    },

    updateDiscountCode: (getToken) => async (registrationId, codeId, payload) => {
      try {
        const token = await getToken();
        const { data } = await axios.put(
          `${baseUrl}/discountCodes/registration/${registrationId}/${codeId}`,
          payload,
          createAuthHeader(token),
        );
        if (data?.status === 1 && data.result?._id) {
          set((state) => {
            const idx = state.discountCodes.findIndex((c) => c._id === codeId);
            if (idx >= 0) state.discountCodes[idx] = data.result;
          });
          return data.result;
        }
        toast.error(data?.error || 'Could not update the discount code');
        return null;
      } catch (error) {
        toast.error(error?.response?.data?.error || 'Could not update the discount code');
        return null;
      }
    },

    deleteDiscountCode: (getToken) => async (registrationId, codeId) => {
      try {
        const token = await getToken();
        const { data } = await axios.delete(
          `${baseUrl}/discountCodes/registration/${registrationId}/${codeId}`,
          createAuthHeader(token),
        );
        if (data?.status === 1) {
          set((state) => {
            state.discountCodes = state.discountCodes.filter((c) => c._id !== codeId);
          });
          toast.success('Discount code deleted');
          return true;
        }
        toast.error(data?.error || 'Could not delete the discount code');
        return false;
      } catch (error) {
        toast.error(error?.response?.data?.error || 'Could not delete the discount code');
        return false;
      }
    },
  })),
);

export default useDiscountCodeStore;
